var E="APP_THEME",P="PDF_REPORT_VIEW";export{E as LOCAL_STORAGE_APP_THEME_KEY,P as LOCAL_STORAGE_PDF_REPORT_VIEW_KEY};
